module.exports = __webpack_public_path__ + "img/Bokhandleren-i-Kabul_Bilde-av-Shah-Mohammad-Rais-i-forste-avsnitt.0dd7bcef.jpg";